import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  gap: 6px;\n\n  & .thumb-img-container {\n    height: 130px;\n    width: 92px;\n    max-width: none;\n    border-radius: 4px;\n    overflow: hidden;\n    display: flex;\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08), 0px 0px 1px 0px rgba(0, 0, 0, 0.04);\n\n    img {\n      object-fit: contain;\n      margin: 0 auto;\n      max-width: 100%;\n      display: block;\n      max-height: 100%;\n    }\n  }\n\n  @media (max-width: 768px) {\n    & .thumb-img-container {\n      height: 96px;\n      width: 68px;\n    }\n\n    button {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 6px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Image from "@/components/common/Image";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/solvook-ui-library";
import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import Link from "next/link";
import React from "react";
import { Subjects } from "src/api/product";
import { SearchRatingWithText } from "../common/RatingWithText";
import ShadowSlideContainer from "../common/ShadowSlideContainer";
import { CouponTag, OnlySolvookTag } from "../Tags";
import { ChipItem } from "./Chips";
import { usePreviewDialogStore } from "./PreviewDialogProvider";
import { useSearchFilterHandler } from "./useSearchFilterHandler";
export const SearchListItemContainer = (param)=>{
    let { href , coreInfoSection , subInfoSection , onClick  } = param;
    return /*#__PURE__*/ _jsx(SearchListItemLI, {
        className: "search-list-item-li",
        children: /*#__PURE__*/ _jsxs(Link, {
            href: href,
            onClick: onClick,
            children: [
                /*#__PURE__*/ _jsx("section", {
                    children: coreInfoSection
                }),
                subInfoSection && /*#__PURE__*/ _jsx("section", {
                    children: subInfoSection
                })
            ]
        })
    });
};
export const CoreInfoSection = (param)=>{
    let { thumbImg , productId , questionNo , avgReviewRating , price , title , badgeText , author , isCouponAvailable , editable , freeTrial  } = param;
    const { isLoggedIn  } = useAuthStore();
    const { openPreviewDialog  } = usePreviewDialogStore();
    // 무료 체험 가능 텍스트 표시 조건
    // 로그인: freeTrial이 있고 eligible이 true
    // 비로그인: freeTrial이 있고 eligible이 false
    const showFreeTrialText = freeTrial ? isLoggedIn ? freeTrial.eligible === true : freeTrial.eligible === false : false;
    const onClickPreviewButton = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        openPreviewDialog({
            id: productId.toString()
        });
        mixpanelEvent("Preview Button Clicked", {
            bookId: productId,
            bookTitle: title,
            Proposition: "검색페이지"
        });
    };
    return /*#__PURE__*/ _jsxs(CoreInfoStack, {
        children: [
            /*#__PURE__*/ _jsx(ThumbArea, {
                src: thumbImg,
                width: 184,
                height: 260,
                previewButton: true,
                onClickPreviewButton: onClickPreviewButton
            }),
            /*#__PURE__*/ _jsx(InfoArea, {
                infoTop: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(ChipsContainer, {
                            className: "chips-container",
                            children: [
                                badgeText && /*#__PURE__*/ _jsx(OnlySolvookTag, {
                                    style: {
                                        position: "relative",
                                        marginBottom: "8px"
                                    },
                                    children: badgeText
                                }),
                                questionNo > 0 && /*#__PURE__*/ _jsxs(ChipItem, {
                                    bgColor: "#F0F4FC",
                                    color: "#326EE5",
                                    children: [
                                        questionNo,
                                        "문항"
                                    ]
                                }),
                                avgReviewRating && avgReviewRating >= 3 && /*#__PURE__*/ _jsx(ChipItem, {
                                    bgColor: "#F7F8FA",
                                    color: "",
                                    children: /*#__PURE__*/ _jsx(SearchRatingWithText, {
                                        rating: avgReviewRating
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Title, {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(Author, {
                            className: "author",
                            children: author
                        })
                    ]
                }),
                infoBottom: /*#__PURE__*/ _jsx(_Fragment, {
                    children: showFreeTrialText ? /*#__PURE__*/ _jsx(FreeTrialText, {
                        children: "무료 체험 가능"
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Price, {
                                children: price
                            }),
                            isCouponAvailable && /*#__PURE__*/ _jsx(CouponTag, {
                                children: "쿠폰"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
export const SubInfoSection = (param)=>{
    let { relatedBook , units , dataTypes  } = param;
    const { filterParams  } = useSearchFilterHandler();
    return /*#__PURE__*/ _jsxs(SubInfoStack, {
        children: [
            relatedBook && filterParams.subject !== Subjects.KO && /*#__PURE__*/ _jsx(SubInfoItem, {
                children: relatedBook
            }),
            (units === null || units === void 0 ? void 0 : units.length) && /*#__PURE__*/ _jsx(SubInfoItem, {
                children: units
            }),
            dataTypes && /*#__PURE__*/ _jsx(SubInfoItem, {
                children: dataTypes
            })
        ]
    });
};
export const SubInfoStack = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(SubInfoContainer, {
        onClick: (e)=>{
            //스크롤 영역으로 클릭이벤트 전파 방지
            e.preventDefault();
            e.stopPropagation();
        },
        children: /*#__PURE__*/ _jsx(ShadowSlideContainer, {
            children: children
        })
    });
};
export const ThumbArea = (param)=>{
    let { src , width , height , onClickPreviewButton , previewButton  } = param;
    return /*#__PURE__*/ _jsxs(ThumbContainer, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "thumb-img-container",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: src,
                    width: width,
                    height: height,
                    alt: "thumb-img"
                })
            }),
            previewButton && /*#__PURE__*/ _jsx(Button, {
                variant: "strokeSecondary",
                sx: (theme)=>{
                    return {
                        padding: "6px 12px",
                        ...theme.typography.subtitle2
                    };
                },
                onClick: onClickPreviewButton,
                children: "샘플 보기"
            })
        ]
    });
};
export const InfoArea = (param)=>{
    let { infoTop , infoBottom  } = param;
    return /*#__PURE__*/ _jsxs(Stack, {
        sx: (theme)=>{
            return {
                justifyContent: "space-between",
                [theme.breakpoints.down("sm")]: {
                    gap: "16px"
                }
            };
        },
        direction: "column",
        children: [
            /*#__PURE__*/ _jsx(Stack, {
                className: "into-top",
                sx: {
                    ".chip": {
                        marginTop: "8px"
                    },
                    ".title + .author": {
                        marginTop: "4px"
                    }
                },
                direction: "column",
                children: infoTop
            }),
            /*#__PURE__*/ _jsx(Stack, {
                className: "info-bottom",
                direction: "row",
                spacing: "6px",
                alignItems: "center",
                children: infoBottom
            })
        ]
    });
};
const SearchListItemLI = styled("li")((param)=>{
    let { theme  } = param;
    return {
        position: "relative",
        width: "100%",
        backgroundColor: "#fff",
        minHeight: "201px",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: theme.palette.grey[100],
        listStyle: "none",
        a: {
            display: "flex",
            flexDirection: "column",
            height: "100%"
        },
        [theme.breakpoints.down("sm")]: {
            borderRadius: 0,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0
        }
    };
});
const CoreInfoStack = styled(Stack)((param)=>{
    let { theme  } = param;
    return {
        padding: "20px",
        gap: "20px",
        flexDirection: "row",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: "16px",
            gap: "16px"
        }
    };
});
const ThumbContainer = styled(Stack)(_templateObject());
export const Title = styled("p")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text.title,
        textOverflow: "ellipsis",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: "2",
        WebkitBoxOrient: "vertical",
        ...theme.typography.subtitle1
    };
});
export const Author = styled("p")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text.secondary,
        ...theme.typography.body1
    };
});
export const Price = styled("p")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text.primary,
        ...theme.typography.h6
    };
});
export const FreeTrialText = styled("p")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text.primary,
        ...theme.typography.h6
    };
});
export const ChipsContainer = styled("div")(_templateObject1());
export const SubInfoContainer = styled(Stack)((param)=>{
    let { theme  } = param;
    return {
        borderRadius: "0 0 6px 6px",
        backgroundColor: theme.palette.grey[0],
        flexDirection: "row",
        overflowX: "auto",
        "span + span": {
            "::before": {
                content: '"|"',
                color: theme.palette.grey[100],
                margin: "0 8px"
            }
        },
        "& ::-webkit-scrollbar": {
            display: "none"
        },
        ">div >div": {
            padding: "12px 20px",
            display: "flex",
            height: "44px"
        },
        [theme.breakpoints.down("sm")]: {
            margin: "0 20px 20px 20px",
            borderRadius: "4px",
            ">div >div": {
                padding: "8px 12px",
                height: "36px"
            }
        }
    };
});
export const SubInfoItem = styled("span")((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text.secondary,
        whiteSpace: "nowrap",
        ...theme.typography.body2
    };
});
